import React from 'react';
import { ErrorFilled } from '@one-thd/sui-icons';
import {
  TextField as MUITextField,
  TextFieldProps,
  InputAdornment,
} from '@material-ui/core';

export const TextField = (props: TextFieldProps) => {
  const { error, InputProps } = props;
  return (
    <MUITextField
      {...props}
      InputProps={{
        endAdornment: error ? (
          <InputAdornment position="end">
            <ErrorFilled size="small" style={{ fill: '#E34A4A' }} />
          </InputAdornment>
        ) : undefined,
        ...InputProps,
      }}
    />
  );
};
